<div class="container paddingtop ">
  <div class="container">
    <div style="padding-bottom: 0.75rem!important;">
      <span class="popupHeading"><b>{{'Notes' | translateOrgSpecific}}</b></span>
      <a (click)="close()"><i class="fas fa-times closebtn"></i></a>
    </div>
    <div class="popup" *ngIf="patientNote.length">
      <div *ngIf="!isCaseManagement">
        <div *ngFor="let list of patientNote; let i = index">
          <div class="card" role="tab">
            <b class="card-header">

              <a role="button" data-toggle="collapse" [href]="'#collapse'+list.sessionId" aria-expanded="true">
                {{list.appointmentDate | date:'M/d/yy, h:mm a'}}
                <i class="fa fa-plus" style="float: right;" aria-hidden="true" data-toggle="collapse"></i>
              </a>

            </b>
            <div [id]="'collapse'+list.sessionId" class="collapse" role="tabpanel">
              <div class="noteContent">
                {{ list.note }}
              </div>

              <div class="noteContent" *ngIf="list.appointmentNote">
                {{'AppointmentNote' | translateOrgSpecific}}: {{list.appointmentNote}}
              </div>

            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isCaseManagement">

        <div *ngFor="let list of patientNote; let i = index">
          <div class="card" role="tab">
            <b class="card-header">

              <a role="button" data-toggle="collapse" [href]="'#collapse'+i" aria-expanded="true">
                <!-- {{list.caseNumber}} - {{list.issuCgy}} - {{list.caseStatus}} -->
                {{list.issuCgy}} - {{list.caseStatus}}

                <i class="fa fa-plus" style="float: right;" aria-hidden="true" data-toggle="collapse"></i>
              </a>

            </b>
            <div [id]="'collapse'+i" class="collapse" role="tabpanel">
              <div class="noteContent">
                <div *ngFor="let obj of list.notesArray;">

                  <label> {{ obj.noteDate | date:'M/d/yy, h:mm a' }}</label> <br>

                  <div *ngIf="!obj.isAppoinment ">
                    <label> {{ obj.notes }}</label> <br>

                  </div>
                  <div *ngIf="obj.isAppoinment">
                    <label> {{'AppointmentNote' | translateOrgSpecific}}: {{obj.notes}}
                    </label>
                  </div>
                  <div *ngIf="obj.caseactionId > 0 ">
                    <label> {{'CaseActionNote' | translateOrgSpecific}}: {{obj.notes}}
                    </label>
                  </div>
                  <div>
                    <label> {{'CreateBy' | translateOrgSpecific}}: {{obj.caseManager}}
                    </label>
                  </div>

                  <br>
                </div>

                <div *ngIf="list.notesArray.length == 0">
                  {{'NoRecordsFound' | translateOrgSpecific}}
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>

    </div>
    <div *ngIf="patientNote.length == 0" style="height: 350px;">
      <label>{{'NoNotesAvailable' | translateOrgSpecific}}</label>
    </div>
  </div>
</div>